import styled from 'styled-components'

export const StUl = styled.ul`
  margin: 0;
  padding: 0;
`
